import {
  AnchoredDropdown,
  Avatar32,
  Chip,
  ChipRemove,
  FieldButton,
  PopoverEmpty,
  PopoverList,
  PopoverRow,
  PopoverSearchInput,
  PopoverSearchRow,
  RowName,
  SectionHeader,
  SectionLabel,
  SectionTag
} from '../../../components';
import { Api } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

let timer;

const TagFriendsPicker = ({ selected = [], onChange }) => {
  const [open, setOpen] = useState(false),
    [query, setQuery] = useState(''),
    [results, setResults] = useState([]),
    { t } = useTranslation();

  useEffect(() => {
    if (!open) return;

    clearTimeout(timer);
    timer = setTimeout(async () => {
      const res = await Api.post('/users/search', { text: query, type: 'athlete' });
      setResults(res || []);
    }, 300);
  }, [open, query]);

  function toggle(user) {
    const exists = selected.find((x) => x._id === user._id);
    onChange(exists ? selected.filter((x) => x._id !== user._id) : [user, ...selected]);
  }

  function summary() {
    if (!selected.length) return t('add.searchToTag', 'Search people to tag');
    if (selected.length === 1) return selected[0].name;
    return `${selected[0].name} + ${selected.length - 1} more`;
  }

  return (
    <div>
      <SectionHeader>
        <SectionLabel>02 — {t('add.tagFriends')}</SectionLabel>
        <SectionTag>
          {selected.length ? `${selected.length} selected` : t('common.optional', 'Optional')}
        </SectionTag>
      </SectionHeader>

      <AnchoredDropdown
        open={open}
        onClose={() => setOpen(false)}
        trigger={
          <FieldButton type="button" onClick={() => setOpen((v) => !v)}>
            <span style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="square"
              >
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
              {summary()}
            </span>
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="square"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </FieldButton>
        }
        panel={
          <>
            <PopoverSearchRow>
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="square"
                style={{ flex: 'none' }}
              >
                <circle cx="11" cy="11" r="7" />
                <path d="m21 21-4.3-4.3" />
              </svg>
              <PopoverSearchInput
                autoFocus
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder={t('add.searchFriends', 'Search friends')}
              />
            </PopoverSearchRow>

            <PopoverList>
              {results.map((f) => {
                const isSelected = !!selected.find((x) => x._id === f._id);
                return (
                  <PopoverRow
                    key={f._id}
                    type="button"
                    $selected={isSelected}
                    onClick={() => toggle(f)}
                  >
                    <Avatar32 $selected={isSelected} $src={f.avatar}>
                      {!f.avatar &&
                        (f.name || '')
                          .split(' ')
                          .map((p) => p[0])
                          .join('')
                          .slice(0, 2)}
                    </Avatar32>
                    <span style={{ minWidth: 0 }}>
                      <RowName>{f.name}</RowName>
                    </span>
                  </PopoverRow>
                );
              })}

              {!results.length && <PopoverEmpty>{t('add.noUserFound')}</PopoverEmpty>}
            </PopoverList>
          </>
        }
      />

      {!!selected.length && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, paddingTop: 12 }}>
          {selected.map((f) => (
            <Chip key={f._id}>
              {f.name}
              <ChipRemove type="button" aria-label="Remove tag" onClick={() => toggle(f)}>
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeLinecap="square"
                >
                  <path d="M18 6 6 18" />
                  <path d="m6 6 12 12" />
                </svg>
              </ChipRemove>
            </Chip>
          ))}
        </div>
      )}
    </div>
  );
};

export default TagFriendsPicker;
